import {Routes} from '@angular/router';
import {TokenResolverComponent} from '@features/token-resolver/token-resolver.component';
import {UserVerificationComponent} from '@features/user-verification/user-verification.component';
import {VerificationCompleteComponent} from '@features/verification-complete/verification-complete.component';
import {NotFoundComponent} from '@features/not-found/not-found.component';
import {InstituteVerificationComponent} from '@features/institute-verification/institute-verification.component';



export const routes: Routes = [
  {
    path: '',
    component: TokenResolverComponent
  },
  {
    path: 'user',
    component: UserVerificationComponent
  },
  {
    path: 'institute',
    component: InstituteVerificationComponent
  },
  {
    path: 'verification-complete',
    component: VerificationCompleteComponent
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  }
];
